/**
 * Created by matheusmorett on 11/7/17.
 */

import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import "./../SideMenu.scss";

export default class SideMenuFaq extends Component {

    render() {


        return (
            <div className="side-menu">
                <ul>
                    {
                        this.props.items.map((i, index) => {
                            return (
                                <li key={index} className={(i.active === true ? "active ": "")}>
                                    <Link to={i.link}>
                                        <div>
                                            {i.name}
                                        </div>
                                        <div className="mobile-name">
                                            <i className={"fa " + i.icon}></i>
                                        </div>
                                    </Link>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        )

    }

}


